import { useConversations } from '@entities/Conversation/hooks';
import { formatTabTitle } from '@features/conversations/services/tabTitle';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

/**
 * Keeps the browser tab title in sync with the number of conversations holding
 * unread messages, so a background tab still signals an incoming message.
 *
 * The count comes from the same cached conversation list as the sidebar dot —
 * one source of truth, no second counter to drift.
 */
export const useUnreadTabTitle = (): void => {
  const { asPath } = useRouter();
  const { data } = useConversations();

  const unreadConversations = data?.items?.filter(conversation => !!conversation.unread).length ?? 0;

  useEffect(() => {
    // Re-read the title on every run: a route change lets next/head write the page's
    // own title back, and the badge has to be reapplied on top of it.
    document.title = formatTabTitle(document.title, unreadConversations);
  }, [unreadConversations, asPath]);
};
